var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 19.3333H2.66667C2.48986 19.3333 2.32029 19.2631 2.19526 19.1381C2.07024 19.013 2 18.8435 2 18.6667C2 18.4899 2.07024 18.3203 2.19526 18.1953C2.32029 18.0702 2.48986 18 2.66667 18H21.3333C21.5101 18 21.6797 18.0702 21.8047 18.1953C21.9298 18.3203 22 18.4899 22 18.6667C22 18.8435 21.9298 19.013 21.8047 19.1381C21.6797 19.2631 21.5101 19.3333 21.3333 19.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 12.6667H2.66667C2.48986 12.6667 2.32029 12.5965 2.19526 12.4714C2.07024 12.3464 2 12.1769 2 12C2 11.8232 2.07024 11.6537 2.19526 11.5286C2.32029 11.4036 2.48986 11.3334 2.66667 11.3334H21.3333C21.5101 11.3334 21.6797 11.4036 21.8047 11.5286C21.9298 11.6537 22 11.8232 22 12C22 12.1769 21.9298 12.3464 21.8047 12.4714C21.6797 12.5965 21.5101 12.6667 21.3333 12.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 5.99996H2.66667C2.48986 5.99996 2.32029 5.92972 2.19526 5.8047C2.07024 5.67967 2 5.5101 2 5.33329C2 5.15648 2.07024 4.98691 2.19526 4.86189C2.32029 4.73686 2.48986 4.66663 2.66667 4.66663H21.3333C21.5101 4.66663 21.6797 4.73686 21.8047 4.86189C21.9298 4.98691 22 5.15648 22 5.33329C22 5.5101 21.9298 5.67967 21.8047 5.8047C21.6797 5.92972 21.5101 5.99996 21.3333 5.99996Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.fd6c8e01d4b102163f07adc8be0c2ffc.svg";
export { ForwardRef as ReactComponent };